<template>
  <div class="flex flex-row gap-x-1">
    <div v-for="index in steps" :key="index" class="step" :class="{ current: step >= index }" />
  </div>
</template>

<script>
export default {
  name: 'StepLines',
  props: {
    steps: Number,
    step: Number,
  },
};
</script>

<style lang="scss" scoped>
.step {
  min-width: 58.5px;
  height: 4px;
  background: #d9d9d9;
  border-radius: 17px;

  &.current {
    background: #3630f8;
  }
}
</style>
